import { http } from "./api";
import dayjs from "dayjs";

// The calendar day the user sees a date on, e.g. "2026-10-17". Sent next to the instant, which older APIs read.
const calendarDay = (date) => dayjs(date).format('YYYY-MM-DD');

export const addEventAPI = (event) => {
  return http.post('/events',
    {
      "title": event.title,
      "description": event.description,
      "date": event.date.toISOString(),
      "day": calendarDay(event.date),
      "icon": event.icon,
      "color": event.color,
      "rating": event.rating,
      "width": event.width,
      "height": event.height,
      "category": event.category,
      "order": event.order,
      "pos_x": event.pos_x,
      "pos_y": event.pos_y,
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};

export const updateEventAPI = (event) => {
  return http.put(`/events/${event.id}`,
    {
      "title": event.title,
      "description": event.description,
      "date": event.date.toISOString(),
      "day": calendarDay(event.date),
      "icon": event.icon,
      "color": event.color,
      "rating": event.rating,
      "width": event.width,
      "height": event.height,
      "category": event.category,
      "pos_x": event.pos_x,
      "pos_y": event.pos_y,
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
};

export const moveEventAPI = (id, date, order) => {
  return http.patch(`/events/${id}`,
    {
      "date": date.toISOString(),
      "day": calendarDay(date),
      "order": +order
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const orderEventAPI = (id, order) => {
  return http.patch(`/events/${id}`,
    {
      "order": +order
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const swapEventsOrder = (event1, event2) => {
  return http.put(`/events`, [
    {
      "id": event1.id,
      "order": event2.order
    },
    {
      "id": event2.id,
      "order": event1.order
    }
  ],
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const copyEventAPI = (event, date) => {
  const e = { ...event };
  e.date = date;

  return addEventAPI(e);
}

export const deleteEventAPI = (id) => {
  return http.delete(`/events/${id}`,
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};

export const deleteEventsAPI = (ids) => {
  return http.delete(`/events`, {
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`
    },
    data: ids
  });
}

const EVENT_KEYS = ['id', 'title', 'description', 'date', 'color', 'icon', 'rating', 'width', 'height', 'category', 'order', 'pos_x', 'pos_y'];

// Sets an event's date to its calendar day, as a dayjs at local midnight, so it shows on the same day in
// every timezone. APIs without `day` send only `date`, an instant of the user's local time.
export const parseEventDate = (event) => {
  event.date = event.day ? dayjs(event.day) : dayjs(event.date, 'YYYY-MM-DDTHH:mm:ssZ');
  delete event.day;
  return event;
};

// Keeps the fields the app uses and turns dates into dayjs objects.
export const parseEvents = (events) => events.map(event => {
  parseEventDate(event);
  Object.keys(event).forEach((key) => EVENT_KEYS.includes(key) || delete event[key]);
  return event;
});

export const getEventsAPI = () => {
  return http.get('/events',
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  ).then((res) => parseEvents(res.data));
};

export const getEventsByDatesAPI = (from, to) => {
  return http.get('/events/dates', {
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('token')}`
    },
    params: {
      from: from.toISOString(),
      to: to.toISOString()
    },
    // A year of events can take longer than the 3s default on a slow connection.
    timeout: 30000,
  }).then((res) => parseEvents(res.data));
}

export const updateEventsPositionsAPI = (events) => {
  return http.post('/events/update_events_positions', events,
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
}